import { ButtonVariant, isButtonVariant } from "../types/button";
import { OptimizelyButtonTypeValue } from "../types/optimizely/blocks";

export const getButtonVariant = ( optiType: OptimizelyButtonTypeValue ): ButtonVariant => {
  if (isButtonVariant(optiType)) {
    return optiType;
  }
  return "link-primary";
}